/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, {
  useContext, useEffect, useMemo, useState,
} from 'react';
import moment from 'moment-timezone';
import { CSVLink } from 'react-csv';
import {
  Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis,
} from 'recharts';
import {
  MapPin, ChevronRight, Download,
} from 'lucide-react';
import './reports.css';
import { Navbar, Sidebar } from '../../components';
import DateRangePicker from '../../components/dateRangePicker';
import FilterModal from './FilterModal';
import { UserContext } from '../../contexts/User';
import { NotificationContext } from '../../contexts/Notification';
import { sendRequest } from '../../api/shootAPI';
import { getDatesInRange } from '../../utils/time';
import {
  generateLocationReport, transformToGraphLocationData, transformToTableLocationData, transformToExportLocationData,
} from '../../utils/report';
import API from '../../api/endpoints';

const softShadow = 'shadow-[0_1px_2px_rgba(14,30,64,0.04)]';

const csvHeaders = [
  { label: 'Date', key: 'date' },
  { label: 'Location Violations', key: 'violationType' },
  { label: 'User', key: 'user' },
];

function KPI({
  icon: Icon, label, value, accent,
}) {
  return (
    <div className={`rounded-xl bg-white ${softShadow} p-4`} style={{ border: '1px solid #e8eaf0' }}>
      <p
        className="text-ink-500 uppercase tracking-wider mb-3"
        style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.05em' }}
      >
        {label}
      </p>
      <div className="flex items-center justify-between">
        <span
          className="tabular-nums leading-none"
          style={{ color: accent, fontSize: '30px', fontWeight: 700 }}
        >
          {value}
        </span>
        <span
          className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: `${accent}1F`, color: accent }}
        >
          <Icon size={18} />
        </span>
      </div>
    </div>
  );
}

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload || payload.length === 0) return null;
  return (
    <div
      className="rounded-xl bg-white px-4 py-3 min-w-[180px]"
      style={{
        border: '1px solid #e8eaf0',
        boxShadow: '0 8px 24px rgba(14,30,64,0.08)',
      }}
    >
      <p className="text-[#0e1e40] mb-2" style={{ fontSize: '14px', fontWeight: 600 }}>{label}</p>
      <div className="flex items-center" style={{ fontSize: '12px' }}>
        <span
          className="rounded-full flex-shrink-0 mr-2"
          style={{ width: '10px', height: '10px', backgroundColor: '#b94f3c' }}
        />
        <span className="text-ink-900 flex-1">Violations</span>
        <span className="text-ink-900 tabular-nums ml-6">
          {payload[0]?.value ?? 0}
        </span>
      </div>
    </div>
  );
}

function DayRow({ day, isOpen, onToggle, idx }) {
  return (
    <div>
      <div
        className="px-5 py-2 bg-surface-page text-ink-500 uppercase tracking-wider"
        style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.05em' }}
      >
        {day.date}
      </div>
      <button
        type="button"
        onClick={onToggle}
        className="w-full grid grid-cols-[1fr_180px_180px] items-center px-5 py-3 hover:bg-surface-page transition"
        style={{ fontSize: '14px' }}
      >
        <span className="flex items-center gap-2 text-ink-900" style={{ fontWeight: 500 }}>
          <ChevronRight
            size={14}
            className="text-ink-500"
            style={{
              transition: 'transform 200ms',
              transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
            }}
          />
          Total
        </span>
        <span className="text-right text-ink-900 tabular-nums">{day.violations.length}</span>
        <span className="text-right pr-2 text-ink-900 tabular-nums">{day.violationMembers.length}</span>
      </button>
      {isOpen && day.violations.length > 0 && day.violations.map((v, i) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={`${idx}-${i}`}
          className="grid grid-cols-[1fr_180px_180px] items-center px-5 py-3"
          style={{ borderTop: '1px solid #f1f2f5', fontSize: '14px' }}
        >
          <span className="flex items-start gap-3 text-ink-900 min-w-0">
            <span className="pl-6 inline-flex items-center gap-2 min-w-0">
              <MapPin size={14} className="flex-shrink-0" style={{ color: '#b94f3c' }} />
              <span className="min-w-0">
                <span className="block text-ink-900">{v.violationType}</span>
                <span
                  className="block text-ink-500 tabular-nums"
                  style={{ fontSize: '11px', marginTop: '2px' }}
                >
                  {v.date}
                </span>
              </span>
            </span>
          </span>
          <span className="text-right tabular-nums" style={{ color: '#b94f3c', fontWeight: 600 }}>
            1
          </span>
          <span className="text-right pr-2 text-ink-500 truncate">{v.user}</span>
        </div>
      ))}
      {isOpen && day.violations.length === 0 && (
        <div
          className="px-5 py-3 text-ink-500 italic"
          style={{ borderTop: '1px solid #f1f2f5', fontSize: '12px' }}
        >
          No violations recorded.
        </div>
      )}
    </div>
  );
}

function GeoLocations() {
  const today = new Date();
  const { displayNotification } = useContext(NotificationContext);
  const { activeWorkspace } = useContext(UserContext);
  const [date, setDate] = useState([new Date(moment(today).subtract(6, 'days')), today]);
  const [members, setMembers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [locationViolations, setLocationViolations] = useState([]);
  const [teamId, setTeamId] = useState(0);
  const [memberId, setMemberId] = useState(0);
  const [chartData, setChartData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [displayText, setDisplayText] = useState('All');
  const [openDays, setOpenDays] = useState(new Set());

  const fetchTeams = async () => {
    const [startDate, endDate] = date;
    const dates = getDatesInRange(startDate, endDate);
    const startOfDay = moment(dates[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss');
    const endOfDay = moment(dates.at(-1)).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    const { success, data } = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.createTeam(activeWorkspace.id),
      timeout: 30000,
      params: { start: startOfDay, end: endOfDay, searchQuery: '' },
    });
    if (success) {
      setTeams(data.teams);
    } else {
      displayNotification({
        message: 'There was an issue fetching team data in this workspace. Please try again',
        severity: 'error',
      });
    }
  };

  const fetchMembers = async () => {
    const { success, data } = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.members(activeWorkspace.id),
      params: { page: 1, pageSize: 1000 },
    });
    if (success) {
      setMembers(data.members);
    } else {
      displayNotification({
        message: 'There was an issue fetching members data in this workspace. Please try again',
        severity: 'error',
      });
    }
  };

  const fetch = async (url) => {
    const [startDate, endDate] = date;
    const dates = getDatesInRange(startDate, endDate);
    const startOfDay = moment(dates[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss');
    const endOfDay = moment(dates.at(-1)).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    const { success, data } = await sendRequest({
      method: 'get',
      url,
      params: { start: startOfDay, end: endOfDay },
    });
    if (success) {
      setLocationViolations(data);
    } else {
      displayNotification({
        message: 'There was an issue fetching data in this workspace. Please try again',
        severity: 'error',
      });
    }
  };

  const fetchAllData = () => {
    fetch(API.WORKSPACE.workspaceLocationViolations(activeWorkspace.id));
  };

  const fetchData = (filterMemberId) => {
    fetch(API.MEMBER.locationViolations(filterMemberId));
  };

  const handleSearch = async (filterTeamId, filterMemberId) => {
    setTeamId(filterTeamId);
    setMemberId(filterMemberId);
    if (filterTeamId === 0 && filterMemberId === 0) {
      setDisplayText('All');
      fetchAllData();
    } else if (filterTeamId !== 0) {
      const filteredTeam = teams.find((team) => team.id === filterTeamId);
      setDisplayText(filteredTeam?.name || 'All');
      const teamViolations = [];
      filteredTeam?.teamMates?.forEach((mate) => {
        if (mate.member.locationViolations?.length > 0) {
          mate.member.locationViolations.forEach((item) => { teamViolations.push(item); });
        }
      });
      setLocationViolations(teamViolations);
    } else {
      const filterMember = members.find((item) => item.id === filterMemberId);
      setDisplayText(filterMember ? `${filterMember.user.firstName} ${filterMember.user.lastName}` : 'All');
      fetchData(filterMemberId);
    }
  };

  useEffect(() => {
    if (teamId === 0 && memberId === 0) {
      setDisplayText('All');
      fetchAllData();
    } else if (teamId !== 0) {
      const filteredTeam = teams.find((team) => team.id === teamId);
      setDisplayText(filteredTeam?.name || 'All');
      const teamViolations = [];
      filteredTeam?.teamMates?.forEach((m) => {
        if (m.locationViolations?.length > 0) m.locationViolations.forEach((item) => teamViolations.push(item));
      });
      setLocationViolations(teamViolations);
    } else {
      const filterMember = members.find((item) => item.id === memberId);
      setDisplayText(filterMember ? `${filterMember.user.firstName} ${filterMember.user.lastName}` : 'All');
      fetchData(memberId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  useEffect(() => {
    fetchTeams();
    fetchMembers();
    fetchAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const result = generateLocationReport(locationViolations, date[0], date[1]);
    setChartData(transformToGraphLocationData(result));
    const table = transformToTableLocationData(result, members, date[0], date[1]);
    setTableData(table);
    setExportData(transformToExportLocationData(result, members));

    const firstWithData = table.findIndex((d) => d.violations.length > 0);
    setOpenDays(firstWithData >= 0 ? new Set([firstWithData]) : new Set());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationViolations, members]);

  const violationChartData = useMemo(
    () => chartData.map((d) => ({ date: d.date, Violations: d.Violations })),
    [chartData],
  );

  const toggleDay = (idx) => {
    setOpenDays((prev) => {
      const next = new Set(prev);
      if (next.has(idx)) next.delete(idx); else next.add(idx);
      return next;
    });
  };

  const totalViolations = locationViolations.length;

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="screen-wrapper">
        <div className="screen-header" style={{ fontFamily: 'Inter, sans-serif' }}>
          {/* Title row */}
          <div className="flex flex-col gap-3 mb-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="min-w-0 flex-1">
              <h1
                className="font-bold text-ink-900 leading-tight truncate text-2xl lg:text-[32px] lg:leading-10"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                Geolocation Results:&nbsp;
                {displayText}
              </h1>
            </div>
            <div className="flex flex-wrap items-center gap-2 sm:gap-3 sm:justify-end w-full sm:w-auto">
              <div className="flex-1 sm:flex-none min-w-0">
                <DateRangePicker
                  value={date}
                  onChange={(_date) => setDate(_date)}
                  className="w-auto"
                />
              </div>
              <FilterModal
                handleSearch={handleSearch}
                members={members}
                teams={teams}
                pending={{ teams: false, members: false }}
                isActive={teamId !== 0 || memberId !== 0}
              />
            </div>
          </div>

          <div className="space-y-5">
            {/* KPI strip */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              <KPI
                icon={MapPin}
                label="Total Number of Violations"
                value={totalViolations}
                accent={totalViolations > 0 ? '#b94f3c' : '#53A551'}
              />
            </div>

            {/* Chart */}
            <div
              className={`rounded-xl bg-white ${softShadow} p-5`}
              style={{ border: '1px solid #e8eaf0' }}
            >
              <p
                className="text-ink-500 uppercase tracking-wider mb-4"
                style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.05em' }}
              >
                Daily Violations
              </p>
              <div className="h-72">
                <ResponsiveContainer width="100%" height="100%">
                  <AreaChart
                    data={violationChartData}
                    margin={{ top: 8, right: 8, left: -8, bottom: 0 }}
                  >
                    <defs>
                      <linearGradient id="violationFill" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#b94f3c" stopOpacity={0.25} />
                        <stop offset="100%" stopColor="#b94f3c" stopOpacity={0} />
                      </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e0e1e6" />
                    <XAxis
                      dataKey="date"
                      tick={{ fontSize: 11, fill: '#546077' }}
                      axisLine={{ stroke: '#e0e1e6' }}
                      tickLine={false}
                      interval="preserveStartEnd"
                      minTickGap={20}
                    />
                    <YAxis
                      tick={{ fontSize: 11, fill: '#546077' }}
                      axisLine={{ stroke: '#e0e1e6' }}
                      tickLine={false}
                      allowDecimals={false}
                    />
                    <Tooltip
                      cursor={{ stroke: '#e0e1e6', strokeWidth: 1 }}
                      content={<ChartTooltip />}
                    />
                    <Area
                      type="monotone"
                      dataKey="Violations"
                      stroke="#b94f3c"
                      strokeWidth={2}
                      fill="url(#violationFill)"
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>

            {/* Geolocation Audit */}
            <div
              className={`rounded-xl bg-white ${softShadow} overflow-hidden`}
              style={{ border: '1px solid #e8eaf0' }}
            >
              <div className="flex items-center justify-between px-5 py-4">
                <h3 className="text-ink-900" style={{ fontSize: '16px', fontWeight: 600 }}>
                  Geolocation Audit
                </h3>
                <CSVLink data={exportData} headers={csvHeaders} filename="Report.csv">
                  <button
                    type="button"
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-[8px] text-ink-900 bg-white hover:text-brand-700 transition"
                    style={{
                      border: '1px solid #e0e1e6',
                      fontSize: '12px',
                      fontWeight: 600,
                    }}
                  >
                    <Download size={12} />
                    Export Table
                  </button>
                </CSVLink>
              </div>
              <div
                className="grid grid-cols-[1fr_180px_180px] items-center px-5 py-3 text-ink-500"
                style={{
                  borderBottom: '1px solid #f1f2f5',
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                <span>Date/Time</span>
                <span className="text-right">Location Violations</span>
                <span className="text-right pr-2">User</span>
              </div>
              <div>
                {tableData.length === 0 && (
                  <div className="px-5 py-8 text-center text-ink-500" style={{ fontSize: '14px' }}>
                    No data in selected range.
                  </div>
                )}
                {tableData.map((day, idx) => (
                  <DayRow
                    // eslint-disable-next-line react/no-array-index-key
                    key={idx}
                    idx={idx}
                    day={day}
                    isOpen={openDays.has(idx)}
                    onToggle={() => toggleDay(idx)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GeoLocations;
